export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    align: 'center',
    fixed: 'left',
    width: 50,
    slots: { default: 'opt' },
    className: 'col-opt',
    visible: !that.disabled,
  },
  {
    title: that.$l('table_label_goodsSizeSpec') || 'SIZE',
    field: 'goodsSizeSpec',
    headerAlign: 'center',
    align: 'left',
    minWidth: 120,
    editRender: {
      name: 'ElInput',
      props: {
        maxlength: 200,
        clearable: true,
        size: 'mini',
      },
    },
  },
  {
    title: that.$l('table_label_quotationCasePack') || 'Case Pack',
    field: 'quotationCasePack',
    align: 'center',
    width: 120,
    editRender: {
      name: 'ElInputNumber',
      props: {
        min: 0,
        precision: 0,
        controls: false,
        clearable: true,
        size: 'mini',
      },
    },
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_quotationMoq') || 'MOQ',
    field: 'quotationMoq',
    headerAlign: 'center',
    align: 'left',
    minWidth: 130,
    editRender: {
      name: 'ElInput',
      props: {
        maxlength: 200,
        clearable: true,
        size: 'mini',
      },
    },
  },
  {
    title: that.$l('table_label_quotationMoqUnit') || '报价起订量单位',
    field: 'quotationMoqUnit',
    headerAlign: 'center',
    align: 'left',
    minWidth: 130,
    editRender: {
      name: 'dict-select',
      props: {
        body: { dictType: 'quotedUnit' },
        url: '/master/common/dict/biz',
        filterable: true,
        clearable: true,
        size: 'mini',
      },
    },
    showHeaderOverflow: true,
    showOverflow: true,
  },

  {
    title: that.$l('table_label_quotationPrice') || 'Price',
    field: 'quotationPrice',
    align: 'center',
    width: 150,
    editRender: {
      name: 'ElInputNumber',
      props: {
        min: 0,
        precision: 2,
        controls: false,
        clearable: true,
        size: 'mini',
      },
    },
    formatter: ({ cellValue }) => that.format(cellValue),
  },
]
